import FormItemUtil from './FormItemUtil';
import GOTUtil from './GOTUtil';
import PropertyValueType from './PropertyValueType';

export default class GOTPropertiesUtil
{
	//TODO全局初始化时 已清除？
	static getItemPropertyFinalValue(menuItemId,entityId,innerId,entity)
	{
		var _key = FormItemUtil.getFormStoresKey(menuItemId,entityId);
		var formStore = window.parent.window[_key];
		let hasPart = false;
		if(formStore)
		{
			hasPart = true;
			let _properties = formStore.mapItemProperty[entityId+"_"+innerId];
			if(_properties)
				return _properties;
		}
		let item = GOTUtil.getItemXML(entityId,innerId);
		let properties = GOTPropertiesUtil.createNoFormPropertiesObject(item,entityId,innerId,entity);
		if(hasPart)
		{
			formStore.mapItemProperty[entityId+"_"+innerId] = properties;
		}
		else
		{
			let mapItemProperty = {};
			mapItemProperty[entityId+"_"+innerId] = properties;
			window.parent.window[_key] = {mapItemProperty:mapItemProperty};	
		}
		
		return properties;
	}

	static setPropertyValue(item,propertyName,properties,entity,type=0,defaultValue=undefined)
	{
		if(properties.hasOwnProperty(propertyName))
			return properties[propertyName];
		
		if(type==PropertyValueType.PROPERTY_XML)
		{
			var xml = GOTUtil.getProperty(item, propertyName);
			if(!xml)
			{
				properties[propertyName] = xml;
				return properties[propertyName];
			}
			else
			{
				return null;
			}
		}
		
		var name = item.name;
		if(name == "ReportField" || name == "Report" || name == "ReportQuery")
			value = GOTUtil.getReprotFinalValue(item,propertyName);
		else
			var value = GOTUtil.getFinalValue(item, entity,propertyName);

		if(value!=null)
		{
			if(value=="")
			{
				if(defaultValue!=undefined)
				{
					properties[propertyName] = defaultValue;
					return properties[propertyName];
				}
			}
			
			switch(type)
			{
				case PropertyValueType.STRING :
					properties[propertyName] = value;
					break;
				case PropertyValueType.BOOLEAN :
					properties[propertyName] = (value=="true"?true:false);
					break;
				case PropertyValueType.INT :
					properties[propertyName] = parseInt(value==""?"0":value);
					break;
				default :
					throw new Error("undefined PropertyValueType");
			}
			
			return properties[propertyName];
		}
		else
		{
			return null;
		}
	}

	static createNoFormPropertiesObject(item,entityId,innerId,entity)
	{
		if(!item)
			return null;		
		
		var itemName = item.qname;
		var itemType;
		if(item.hasOwnProperty("type"))
		{
			itemType = item.type;
		}
		
		var propertyName;
		var properties = {};
		if(["String", "Long", "Decimal","Date","Time","Boolean","Enum"].indexOf(itemType)!=-1)
		{
			propertyName = "Alignment";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
			
			propertyName = "Regular";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
			
			propertyName = "NotNull";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
			
			propertyName = "AllowEdit";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);

			propertyName = "AllowEditOnCreate";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
			
			propertyName = "Default";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);

			propertyName = "SkipTab";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
			
			propertyName = "DisplayHeight";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.INT, 1);
			
			propertyName = "DisplayLength";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.INT);
			
			propertyName = "Label";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
		}
		
		if(itemType=="Date")
		{
			propertyName = "Seperator";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.STRING,"-");
			
			propertyName = "NumOfYear";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.INT,4);
			
			propertyName = "NumOfMonth";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.INT,2);
				
			propertyName = "NumOfDay";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.INT,2);
			
			propertyName = "Show1970";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN,false);
		}
		
		if(itemType=="Long" || itemType=="Decimal")
		{
			propertyName = "ShowZero";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);

			propertyName = "ThousandSeperator";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
		
			propertyName = "AllowNegative";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
		}
		
		if(itemType=="Decimal")
		{
			propertyName = "NumOfDecimals";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.INT, 2);
			
			propertyName = "ShowDecimals";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.INT);
			
			propertyName = "RoundOff";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
			
			propertyName = "ThousandSeperator";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
			
			propertyName = "AllowNegative";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
			
			propertyName = "ShowZero";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
		}
		
		if(itemType=="String")
		{
			propertyName = "StringSize";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.INT, 32);
			
			propertyName = "Trim";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
			
			propertyName = "ChangeCase";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
			
			propertyName = "FormLookup";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
			
			if(itemType == "StringEditor")
			{
				propertyName = "ReturnLookup";
				GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
				
				//propertyName = "ValidateLookup";
				//GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
			}
		}
		
		if(itemType=="Time")
		{
			propertyName = "ShowHour";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
			
			propertyName = "ShowMinute";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
			
			propertyName = "ShowSecond";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.BOOLEAN);
		}
		
		var dataProvider;
		if(itemType=="Enum")
		{
			if(itemName == "TableField")
			{
				dataProvider = GOTUtil.getDataSourceByTableField(item);
			}
			else if(itemName == "ReportField")
			{
				dataProvider = GOTUtil.getDataSourceByReportField(item);
			}
			else
			{
				dataProvider = GOTUtil.getDataSourceByDataType({refentityid:item.id});
			}
			
			properties["DataProvider"] = dataProvider;
		}
		
		
		if(itemName == "Enum")
		{
			dataProvider = GOTUtil.getDataSourceByEnum({refentityid:item.id});
			properties["DataProvider"] = dataProvider;
			
			propertyName = "Label";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
			
			propertyName = "HelpText";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity);
			
			propertyName = "DisplayLength";
			GOTPropertiesUtil.setPropertyValue(item,propertyName,properties,entity,PropertyValueType.INT);
		}
		
		return properties;
	}
}


// WEBPACK FOOTER //
// ./src/utils/GOTPropertiesUtil.js